export const REVENUE_START = "REVENUE_START";
export const GET_REVENUE = "GET_REVENUE";
export const GET_REVENUE_SUCCESS = "GET_REVENUE_SUCCESS";
export const CREATE_REVENUE = "CREATE_REVENUE";
export const UPDATE_REVENUE = "UPDATE_REVENUE";
export const SUCCESS_COMMON = "SUCCESS_COMMON";
export const REVENUE_FAIL = "REVENUE_FAIL";
